import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLAnchorElement> {
  click(e: MouseEvent): void {
    e.preventDefault()
    document.querySelector('body')?.scrollIntoView({ behavior: 'smooth' })
  }
}
